import React, { memo } from 'react';

export interface CarouselNavProps {
  direction: 'prev' | 'next';
  onClick: () => void;
  visible: boolean;
}

function CarouselNavComponent({
  direction,
  onClick,
  visible
}: CarouselNavProps): React.ReactElement | null {
  if (!visible) return null;
  const label = direction === 'prev' ? 'Previous' : 'Next';
  const mod = direction === 'prev' ? '--prev' : '--next';
  return (
    <button
      type="button"
      className={`attachment-carousel__nav attachment-carousel__nav${mod}`}
      onClick={onClick}
      aria-label={label}
    >
      <span className="attachment-carousel__nav-icon">
        {direction === 'prev' ? '‹' : '›'}
      </span>
    </button>
  );
}

export const CarouselNav = memo(CarouselNavComponent);
CarouselNav.displayName = 'CarouselNav';
